import React, { ComponentProps } from 'react';
import { Button } from '@sls-react/components/Form/Button';
import classNames from 'classnames';

type Props = Omit<ComponentProps<typeof Button>, 'variant'> & {
  selected?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
};

// @ts-ignore
export const Tab: React.FC<Props> = React.forwardRef(
  ({ children, className, selected, ...props }, ref) => (
    <Button
      className={classNames(
        selected
          ? 'border-b-4 border-primary-500 whitespace-no-wrap'
          : 'border-b-4 border-transparent hover:border-grey-500 whitespace-no-wrap',
        className,
      )}
      css={`
        border-radius: 0;
      `}
      color="secondary"
      {...props}
      ref={ref}
      variant="text"
    >
      {children}
    </Button>
  ),
);
